import { cloneDeep } from "lodash";
import { OrderShipmentDetails } from "src/_modules/Orders/components";

export default function StatusHistoryTab({
    order
}) {
    return (
        <OrderShipmentDetails details={cloneDeep(order) ?? ''} />
    )
}
